<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"
    class="no-field-space article-type-attribute-editor">

    <sc-dialog-title>
      {{ 'Attribut' | translate: ['erp.ui.articletype-attribute-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>
    <sc-flex-fitting-content [vertical]="true">
        <sc-scroll-pane>
            <sc-padding>
                <form [formGroup]="formGroup">
                    <sc-flex [vertical]="true" [stretchContent]="true">
                        <div>
                            <sc-flex >

                              <mat-form-field appearance="fill" class="identifierPattern">
                                <mat-label>{{ 'Id' | translate: ['erp.entity.articletype.id', translationService.language]}}</mat-label>
                                <input matInput formControlName="id" [disabled]="true">
                              </mat-form-field>

                              <sc-content-spacer></sc-content-spacer>

                                <mat-form-field appearance="fill" class="input-group">
                                    <mat-label>{{ 'Group' | translate: ['erp.entity.articletypeattribute.group', translationService.language]}}</mat-label>
                                    <mat-select formControlName="group" [required]="true">
                                        <mat-option *ngFor="let group of articleType.attributeGroups" [value]="group">
                                            <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <sc-content-spacer></sc-content-spacer>

                                <mat-form-field appearance="fill">
                                    <mat-label>{{ 'Sort Value' | translate: ['erp.entity.articletypeattribute.sort-order', translationService.language]}}</mat-label>
                                    <input matInput formControlName="sortValue">
                                </mat-form-field>
                            </sc-flex>
                        </div>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>
                        <div>
                            <sc-flex >
                                <mat-form-field appearance="fill">
                                    <mat-label>{{ 'Type' | translate: ['erp.entity.articletypeattribute.type', translationService.language]}}</mat-label>
                                    <mat-select formControlName="type" [required]="true">
                                        <mat-option *ngFor="let attributeType of attributeTypes"
                                            [value]="attributeType">
                                            {{ attributeType }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <sc-content-spacer></sc-content-spacer>
                                <sc-dictionary-field class="input-title" [model]="attribute?.name" [maxlength]="255"
                                    defaultLabel="Name" labelDictionaryKey="erp.entity.articletypeattribute.name"
                                    (dictionaryChanged)="onTitleChanged($event)" [required]="true">
                                </sc-dictionary-field>
                            </sc-flex>
                        </div>
                        <sc-content-spacer [vertical]="true"></sc-content-spacer>

                        <div>
                            <sc-flex >
                                <mat-checkbox class="input-mandatory" formControlName="mandatory">
                                    {{ 'Mandatory' | translate: ['erp.entity.articletypeattribute.mandatory', translationService.language]}}
                                </mat-checkbox>
                                <sc-content-spacer *ngIf="!lookupType"></sc-content-spacer>
                                <mat-form-field class="input-default-value" appearance="fill" *ngIf="!lookupType">
                                    <mat-label>{{ 'default Value' | translate: ['erp.entity.articletypeattribute.defaultvalue', translationService.language]}}</mat-label>
                                    <input matInput formControlName="defaultValue">
                                </mat-form-field>
                            </sc-flex>
                        </div>
                    </sc-flex>
                </form>
                <ng-container *ngIf="lookupType">
                    <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>
                    <sc-sub-title>
                      {{ 'Nachschlagewerte' | translate: ['erp.ui.articletype-attribute-editor.subtitle.lookupvalues', translationService.language]}}
                      <sc-content-spacer [grow]="true"></sc-content-spacer>
                      <button mat-stroked-button (click)="addValue()">
                          <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                          {{ 'add' | translate: ['erp.ui.articletype-attribute-editor.action.add-lookupvalue', translationService.language]}}
                      </button>
                    </sc-sub-title>
                    <ng-container *ngFor="let value of attribute?.values">
                        <ng-container *ngIf="value.deleted === false">
                            <sc-content-spacer [vertical]="true"></sc-content-spacer>
                            <div class="value-item" #lookupValueForm>
                                <sc-padding>
                                    <sc-flex *ngIf="selectedValue !== value">
                                        <div>{{value.value}} <span *ngIf="value?.id === attribute.defaultValueId">
                                                (default)</span></div>
                                        <sc-content-spacer [grow]="true"></sc-content-spacer>
                                        <button mat-icon-button class="edit-button" (click)="selectValue(value)">
                                            <mat-icon>
                                                <sc-action-icon iconClass="fa-pencil"></sc-action-icon>
                                            </mat-icon>
                                        </button>
                                        <button mat-icon-button (click)="removeValue(value)">
                                            <sc-action-icon iconClass="fa-trash"></sc-action-icon>
                                        </button>
                                    </sc-flex>
                                    <form [formGroup]="valueFormGroup" *ngIf="selectedValue === value">
                                        <sc-flex >
                                            <mat-form-field appearance="fill" class="input-value">
                                                <mat-label>{{ 'Value' | translate: ['erp.entity.articletype.articletypeattribute.lookupvalue', translationService.language]}}</mat-label>
                                                <input #lookupValueInput name="lookupValueInput" matInput formControlName="value" >
                                            </mat-form-field>
                                            <sc-content-spacer></sc-content-spacer>
                                            <mat-form-field appearance="fill" class="">
                                              <mat-label>{{ 'SortValue' | translate: ['erp.entity.articletype.articletypeattribute.lookupsortvalue', translationService.language]}}</mat-label>
                                              <input #lookupValueInput name="lookupSortValueInput" matInput formControlName="sortValue" >
                                          </mat-form-field>
                                          <sc-content-spacer></sc-content-spacer>
                                            <mat-checkbox class="input-default-value-flag" formControlName="default"
                                                *ngIf="value?.id !== attribute.defaultValueId">
                                                {{ 'Default' | translate: ['erp.entity.articletype.articletypeattribute.default', translationService.language]}}
                                            </mat-checkbox>
                                            <div *ngIf="value?.id === attribute.defaultValueId">
                                                (default)</div>
                                        </sc-flex>
                                    </form>
                                </sc-padding>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </sc-padding>
        </sc-scroll-pane>
    </sc-flex-fitting-content>
    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">Abbrechen</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">Übernehmen</button>
    </sc-actionbar>
</sc-flex>
